export default __webpack_public_path__ + "static/media/logo.white.3bcb0e6a.svg";